module.exports = __webpack_public_path__ + "assets/img/5_1161_big.2dfb9566.jpg";